import type { RegExpGroups } from "./RegExpGroups";
import type { MetadataMatch } from "./types";
import { IconAxureLogo } from "ls/features/disko/icons";
import AxureInlineCard from "./AxureInlineCard.vue";

export type AxureMetadataMatch = MetadataMatch & {
  name: "axure";
  shortcut: string;
};

const patterns = [
  /^(https:\/\/)?(?<shortcut>[a-z0-9]+)\.(axshare|axsites)\.com#?.*?\/?$/i,
  /^(https:\/\/)?[^/]+\.((axure\.cloud)|(axuretest\.com))\/app\/project\/(?<shortcut>[a-z0-9]+)#?.*?\/?$/i,
] as const;

export function axure(url: string): AxureMetadataMatch | undefined {
  for (const pattern of patterns) {
    const result = url.match(pattern) as RegExpGroups<"shortcut">;
    if (!result) continue;

    const shortcut = result.groups?.shortcut.toLowerCase();
    if (!shortcut) continue;

    return {
      name: "axure",
      url,
      shortcut,
      icon: IconAxureLogo,
      inlineCard: AxureInlineCard,
    };
  }

  return undefined;
}
